// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';
import { media } from '../../../../helpers';

export default styled<any, Theme>('div')`
  color: ${props => props.theme.carblock.packageName.color};
  font-size: ${props => props.theme.carblock.packageName.fontSize.default};
  line-height: 1.3em;
  margin: 0.2rem 0 0.4rem 0;
  font-weight: ${props => props.theme.carblock.packageName.fontWeight};

  ${media.lg(css`
    font-size: ${props => props.theme.carblock.packageName.fontSize.lg};
  `)}
`;
